import { useRentalUnitField } from '../../../../../../../../queries/useRentalUnitField';
import { NumberBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../../../../components/ApplicationQuestionReviewItem';
import { ShowIf } from '../../../../../../../components/ShowIf';

interface SquareFeetProps {
    unitGuid: string;
    required: boolean;
    isReview?: boolean;
    showLabel?: boolean;
}

export const SquareFeet: React.FC<SquareFeetProps> = ({ unitGuid, required, isReview = false, showLabel = false }) => {
    const label = 'Square Feet';
    const [squareFeet, set_squareFeet] = useRentalUnitField(
        unitGuid,
        (u) => u.squareFeet,
        (u, v) => ({ ...u, squareFeet: v })
    );

    return (
        <>
            {isReview ? (
                <>
                    <ShowIf showIf={showLabel}>
                        <ApplicationQuestionReviewItem
                            label={label}
                            value={squareFeet?.toLocaleString('en-US')}
                            showLabel={showLabel}
                        />
                    </ShowIf>
                    <ShowIf showIf={!showLabel}>{squareFeet?.toLocaleString('en-US')}</ShowIf>
                </>
            ) : (
                <NumberBox
                    id={`squareFeet_${unitGuid}`}
                    value={squareFeet}
                    onChange={(value) => set_squareFeet(value)}
                    required={required}
                    label={showLabel ? label : undefined}
                />
            )}
        </>
    );
};
